import { MouseEventHandler, useState } from 'react';

import { useContextMediaQuery } from '@core/context';
import { EButtonVariant } from '@core/type';

import { ModalAutoSavings } from '../modal/modal-auto-savings/ModalAutoSavings';
import { ButtonAutoSavings } from './ButtonAutoSavings';
import { ButtonAutoSavingsBadgeProps } from './interface-product-card';

export const ButtonAutoSavingsBadge = ({
  product,
  buttonProps,
  title,
  quantity,
}: ButtonAutoSavingsBadgeProps) => {
  const { isMobile } = useContextMediaQuery();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleOpenModal: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();

    setIsModalOpen(true);
  };

  return (
    <>
      <ButtonAutoSavings
        onClick={handleOpenModal}
        hiddenIcon={isMobile}
        variant={EButtonVariant.CONTAINED}
        title={title}
        {...buttonProps}
      />
      <ModalAutoSavings
        isOpen={isModalOpen}
        product={product}
        quantity={quantity}
        onCloseModal={() => setIsModalOpen(false)}
      />
    </>
  );
};
